import { createSlice } from "@reduxjs/toolkit";
import {
    fetchReferralRewardTableColumnNames,
    fetchAllReferralReward,
    createReferralReward,
    updateReferralReward,
    deleteReferralReward,
    activateDeactivateReferralReward,
    uploadReferrelDoc
} from "./thunk";

const referralRewardSlice = createSlice({
  name: "ReferralReward",
  initialState: {
    referralReward: [],
    tableColumnNames: [],
    uploadedDocUrl: null,
    docLoad: false, 
    loading: false,
    Headerload: false,
    error: null,
  },
   reducers: {
    clearUploadedReferralDocUrl: (state) => {
      state.uploadedDocUrl = null;
    }
  },
  extraReducers: (builder) => {
    builder

      // Fetch Referral Reward Table Column Names
      .addCase(fetchReferralRewardTableColumnNames.pending, (state) => {
        state.Headerload = true;
        state.error = null;
      })
      .addCase(fetchReferralRewardTableColumnNames.fulfilled, (state, action) => {
        state.Headerload = false;
        state.tableColumnNames = action.payload;
      })
      .addCase(fetchReferralRewardTableColumnNames.rejected, (state, action) => {
        state.Headerload = false;
        state.error = action.payload;
      })

      // Get All Referral Reward
      .addCase(fetchAllReferralReward.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchAllReferralReward.fulfilled, (state, action) => {
        state.loading = false;
        state.referralReward = action.payload;
      })
      .addCase(fetchAllReferralReward.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // Add Referral Reward
      .addCase(createReferralReward.pending, (state) => {
        state.error = null;
      })
      .addCase(createReferralReward.fulfilled, (state, action) => {
        state.referralReward = [action.payload.data[0], ...state.referralReward];
      })
      .addCase(createReferralReward.rejected, (state, action) => {
        state.error = action.payload;
      })

      // Update Referral Reward
      .addCase(updateReferralReward.pending, (state) => {
        state.error = null;
      })
      .addCase(updateReferralReward.fulfilled, (state, action) => {
        const index = state.referralReward.findIndex(
          (item) => item.ID === action.payload[0].ID
        );

        if (index !== -1) {
          state.referralReward[index] = action.payload[0];
        }
      })
      .addCase(updateReferralReward.rejected, (state, action) => {
        state.error = action.payload;
      })

      // Delete Referral Reward
      .addCase(deleteReferralReward.pending, (state) => {
        state.error = null;
      })
      .addCase(deleteReferralReward.fulfilled, (state, action) => {
        const deletedIds = action.payload.map((item) => item.ID);

        // Filter out the deleted items
        state.referralReward = state.referralReward.filter(
          (item) => !deletedIds.includes(item.ID)
        );
      })
      .addCase(deleteReferralReward.rejected, (state, action) => {
        state.error = action.payload;
      })

      // Active Deactive Referral Reward
      .addCase(activateDeactivateReferralReward.pending, (state) => {
        state.error = null;
      })
      .addCase(activateDeactivateReferralReward.fulfilled, (state, action) => {
        if (action.payload) {
          const updatedReferralReward = action.payload[0];

          state.referralReward = state.referralReward.map((item) => item.ID === updatedReferralReward.ID ? {...item, IsActive: updatedReferralReward.IsActive} : item)
        }
      })
      .addCase(activateDeactivateReferralReward.rejected, (state, action) => {
        state.error = action.payload;
      })

       // Upload Topic Image Icon
      .addCase(uploadReferrelDoc.pending, (state) => {
        state.docLoad = true;
        state.error = null;
      })
      .addCase(uploadReferrelDoc.fulfilled, (state, action) => {
        state.docLoad = false;
        state.uploadedDocUrl = action.payload; 
      })
      .addCase(uploadReferrelDoc.rejected, (state, action) => {
        state.docLoad = false;
        state.error = action.payload;
      })
    },
});

export const { clearUploadedReferralDocUrl } = referralRewardSlice.actions;
export default referralRewardSlice.reducer;
